import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import SmsDogrulamaSaveAPI, { SmsDogrulamaSaveRequest } from "../../../apis/OB/SaveApi/SmsDogrulamaSaveAPI";
import SmsKoduKontrolAPI, { SmsDogrulamaKontrolRequest } from "../../../apis/OB/SaveApi/SmsKoduKontrolAPI";
import Recaptcha from "../../Recaptcha";


const TcTelefonSmsControlPopupOnPage = ({ tcKimlikNo, cepTelefonu, onClose, onVerificationComplete }: any) => {
  const [isError, setIsError] = useState(false);
  const [goSmsControl, setGoSmsControl] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const [isActive, setIsActive] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [errorContent, setErrorContent] = useState("");
  const [refNo, setRefNo] = useState<any>(undefined);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const recaptchaTokenRef: any = useRef();

  useEffect(() => {
    if (goSmsControl) {
      setIsActive(true);
    }
  }, [goSmsControl]);

  useEffect(() => {
    let interval: any = null;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const restartTimer = () => {
    setSeconds(60);
    setIsActive(true);
  };

  const handleRecaptchaChange = (value: boolean) => {
    setRecaptchaPassed(value);
  };

  const maskPhoneNumber = (phoneNumber: string): string => {
    const cleanedNumber = phoneNumber.replace(/\s+/g, "");
    if (cleanedNumber.length === 13 && cleanedNumber.startsWith("+90")) {
      const countryCode = cleanedNumber.substring(0, 3);
      const firstTwoDigits = cleanedNumber.substring(3, 5);
      const lastTwoDigits = cleanedNumber.substring(cleanedNumber.length - 2);
      return `${countryCode} ${firstTwoDigits}* *** ** ${lastTwoDigits}`;
    }
    return phoneNumber;
  };

  const sendSms = async () => {
    const recaptchaToken = await recaptchaTokenRef.current.handleSubmit();
    const request = new SmsDogrulamaSaveRequest(
      cepTelefonu.replace(/^\+9/, "").replace(/ /g, ""),
      tcKimlikNo,
      undefined,
      undefined,
      undefined,
      recaptchaToken,
      true
    );

    SmsDogrulamaSaveAPI.saveSmsDogrulamaSaveSave(request)
      .then((res:any) => {
        if (res.data.sonuc === 0) {
          setRefNo(request.referansNo);
          setGoSmsControl(true);
        } else {
          setErrorContent(res.data.sonucAciklama);
          setIsError(true);
          setTimeout(() => {
            setIsError(false);
            setErrorContent("");
          }, 4000);
        }
      })
      .catch(() => {
        setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
        setIsError(true);
        setTimeout(() => {
          setIsError(false);
          setErrorContent("");
        }, 4000);
      });
  };

  const verifySmsCode = () => {
    if (smsCode.length < 6) {
      setErrorContent("SMS kodu 6 haneli olmalıdır.");
      setIsError(true);
      setTimeout(() => {
        setIsError(false);
        setErrorContent("");
      }, 4000);
      return;
    }

    const request = new SmsDogrulamaKontrolRequest(tcKimlikNo, refNo, smsCode, undefined, undefined);
    SmsKoduKontrolAPI.saveSmsDogrulamaKontrolSave(request)
      .then((res) => {
        if (res.data[0].sonuc === 0) {
            onVerificationComplete(true);


          onClose();
        } else {
          setErrorContent(res.data[0].sonucAciklama);
          setIsError(true);
          setTimeout(() => {
            setIsError(false);
            setErrorContent("");
          }, 4000);
        }
      })
      .catch(() => {
        setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
        setIsError(true);
        setTimeout(() => {
          setIsError(false);
          setErrorContent("");
        }, 4000);
      });
  };

  return (
<Dialog open={true} onClose={onClose}>
{!goSmsControl ? (
        <>
          <DialogTitle>
            Telefon Kontrolü
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <TextField
                size="small"
                fullWidth
                value={tcKimlikNo}
                label="T.C. Kimlik No"
                variant="outlined"
                disabled
              />
              <TextField
                size="small"
                fullWidth
                value={maskPhoneNumber(cepTelefonu)}
                label="Cep Telefonu"
                variant="outlined"
                disabled
              />
              <Collapse in={isError}>
                <Alert severity="error">{errorContent}</Alert>
              </Collapse>
              <Recaptcha ref={recaptchaTokenRef} changeHandleRecaptcha={handleRecaptchaChange} />
            </Box>
          </DialogContent>
          <DialogActions>
          {/* <Button onClick={onClose} color="secondary">
  İptal
</Button> */}

            <Button onClick={sendSms} color="primary" disabled={recaptchaPassed}>
              Gönder
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogTitle>
            SMS Kontrolü
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              {isActive ? (
                <Typography>
                  {maskPhoneNumber(cepTelefonu)} numaralı telefona gönderilen SMS kodunu giriniz.
                </Typography>
              ) : (
                <Typography>Kodu girmediniz. Tekrar göndermeyi deneyin.</Typography>
              )}
              <Collapse in={isError}>
                <Alert severity="error">{errorContent}</Alert>
              </Collapse>
              {isActive && (
                <TextField
                  size="small"
                  fullWidth
                  name="smsCode"
                  label="SMS Kodu"
                  variant="outlined"
                  value={smsCode}
                  onChange={(e) => setSmsCode(e.target.value.substring(0, 6))}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      verifySmsCode(); 
                    }
                  }}
                />
              )}
              <Typography variant="h6">{seconds}</Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={restartTimer} disabled={isActive}>
              Tekrar Gönder
            </Button>
            <Button onClick={verifySmsCode} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default TcTelefonSmsControlPopupOnPage;
